import backend from 'network/BackendFetchAdapter';
import { AgencyCreation } from 'types/AgencyCreation';
import { Agency } from 'types/Agency';

export const agencyApi = {
  createAgency: (data: AgencyCreation): Promise<Agency> => backend.post('/api/agencies', data),
};
